import { css } from '@emotion/react';

export const show = css`
  display: block;
`;

export const hide = css`
  display: none;
`;

export const root = css`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100%;
  background-color: white;
  z-index: var(--z-dialog);
`;

export const titleWrapper = css`
  position: fixed;
  width: 100%;
  background-color: white;
  top: 0;
`;

export const titleMotion = css`
  animation: titleMotion 0.2s;

  @keyframes titleMotion {
    from {
      transform: translateY(-50px);
    }
    to {
      transform: translateY(0px);
    }
  }
`;

export const title = css`
  padding: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: black;
  font-size: 17px;
  font-weight: bold;
  border-bottom: 0.5px solid #dee2e6;
`;

export const titleTextWrapper = css`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const titleText = css`
  /* move left half icon size(24px) */
  transform: translateX(-12px);
`;

const noFooterAndTitle = css`
  height: 100%;
`;

const onlyHasHeader = css`
  height: calc(100% - 48px);
`;

const onlyHasFooter = css`
  height: calc(100% - 72px);
`;

const hasHeaderFooter = css`
  height: calc(100% - 121px);
`;

function getHeight(isExistFooter: boolean, hasTitle: boolean) {
  if (isExistFooter && !hasTitle) {
    return onlyHasFooter;
  }
  if (!isExistFooter && hasTitle) {
    return onlyHasHeader;
  }
  if (!isExistFooter && !hasTitle) {
    return noFooterAndTitle;
  }
  if (isExistFooter && hasTitle) {
    return hasHeaderFooter;
  }

  return hasHeaderFooter;
}

export const content = (isExistFooter: boolean, hasTitle = true) => css`
  ${getHeight(isExistFooter, hasTitle)};
  padding: 24px 16px 0px 16px;
  margin-top: ${hasTitle ? '48px' : 0};
  font-size: 15px;
  letter-spacing: -0.2px;
  background-color: white;
  overflow: auto;
`;

export const footerWrapper = css`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
`;

export const footer = css`
  display: flex;
  flex-direction: row;
  padding: 12px 16px;
  background-color: white;
`;

export const optionButton = css`
  margin-right: 8px;
  word-break: keep-all;

  button {
    padding: 0 12px;
  }
`;

export const equalOptionButton = css`
  width: 100%;

  & > span {
    width: 100%;
    justify-content: center;

    & > button {
      width: 100%;
    }
  }
`;

export const confirmButton = css`
  width: 100%;
  & > span {
    width: 100%;
    justify-content: center;

    & > button {
      width: 100%;
    }
  }
`;
